import React, { FC } from 'react';
import UpdateLineItemButton from 'components/SalesArea/pages/Cart/UpdateLineItemSelector';
import { useCheckoutLineItemsUpdateMutation } from 'graphql/shopify-store-front-api/queries/types.d';

type Props = {
  /**
   * 数量変更対象のlineItemId
   */
  lineItemId: string;

  /**
   * 数量変更対象のvariantId
   */
  variantId: string;

  /**
   * 変更前の数量
   */
  quantity: number;
};

/**
 * 数量変更セレクターのロジック部
 */
const EnhancedUpdateLineItemSelector: FC<Props> = ({
  lineItemId,
  variantId,
  quantity,
}) => {
  const [
    checkoutLineItemsUpdateMutation,
    { loading: checkoutLineItemsUpdateLoading },
  ] = useCheckoutLineItemsUpdateMutation();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    void checkoutLineItemsUpdateMutation({
      variables: {
        checkoutId: localStorage.getItem('checkoutId') ?? '',
        lineItems: [
          {
            id: lineItemId,
            variantId,
            quantity: event.target.value as number,
          },
        ],
      },
    });
  };

  return (
    <UpdateLineItemButton
      quantity={quantity}
      handleChange={handleChange}
      isLoading={checkoutLineItemsUpdateLoading}
    />
  );
};

export default EnhancedUpdateLineItemSelector;
